module.exports = __webpack_public_path__ + "static/media/MartinAqua.32d00c94.svg";